import React, {useState} from 'react';
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import ApiDatabase from 'server'
import {toast} from "react-toastify";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import useLicenceTexts from "components/licences/useLicenceTexts";

const LICENCE_DELETE_ERROR_CODES = ['LICENCE_NOT_DELETABLE', 'LICENCE_NOT_FOUND']

const LicenceDelete = () => {
    const {objID, refreshLoadWorker, tempData} = UseContext()
    const {toggle} = useModal()
    const {translate, getLabel, getTypeWord} = useLicenceTexts()
    const [isDeleting, setIsDeleting] = useState(false)
    const entry = (Array.isArray(tempData?.licences) ? tempData.licences : []).find(licence => licence?._id === objID)
    const t = (key, values) => translate(`delete_modal.${key}`, values)

    const showError = (errorCode) => {
        const key = LICENCE_DELETE_ERROR_CODES.includes(errorCode) ? errorCode : 'default'
        toast.error(t(`errors.${key}`))
    }

    const deleteLicence = (e) => {
        e.preventDefault()
        if (isDeleting) return
        setIsDeleting(true)
        ApiDatabase.postDeleteLicence({ objID },
            (data) => {
                setIsDeleting(false)
                if (data?.success) {
                    refreshLoadWorker()
                    toggle()
                    toast.success(t('success'))
                    return
                }
                showError(data?.errorCode)
            },
            (err) => {
                setIsDeleting(false)
                const errorCode = err?.response?.data?.errorCode
                showError(errorCode)
                // Accepted or deleted meanwhile (another tab, the mobile app): the list on screen is
                // stale, reload it so the cross or the row disappears.
                if (LICENCE_DELETE_ERROR_CODES.includes(errorCode)) {
                    refreshLoadWorker()
                    toggle()
                }
            })
    }

    return (
        <>
            <Modalheader hide={toggle} hideShow={true}>{t('title', {type: entry ? getTypeWord(entry) : ''})}</Modalheader>
            <ModalBody>
                <p className="ft-sm text-gray-500">
                    {t('text', {label: entry ? getLabel(entry) : ''})}
                    {entry?.state === 'pending' ? ` ${t('not_verified')}` : ''}
                </p>
            </ModalBody>
            <ModalFooter>
                <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>{t('cancel')}</Button>
                {/* Button has no destructive colour: the red tint of the mock-up is set here. */}
                <button
                    type="button"
                    disabled={isDeleting}
                    onClick={deleteLicence}
                    className={`h-12 ft-lg py-3 px-6 rounded-md font-medium ${isDeleting ? 'bg-gray-50 text-gray-400' : 'bg-red-100 text-red-700 hover:bg-red-200'}`}
                >
                    {t('confirm')}
                </button>
            </ModalFooter>
        </>
    )
}

const Modaldelete = () => {
    const {objID,refreshLoadWorker,objType}=UseContext()
    const {toggle}=useModal()
    if (objType === 'licence') return <LicenceDelete/>
    const handleDeleted=(e)=>{
        e.preventDefault()
        if(objType==='training'){
            ApiDatabase.postDeleteFormation({ objID },
                (data)=>{
                    if (data.success) {
                        refreshLoadWorker()
                        toggle()
                        toast.success('La formation est supprimée.')
                    }
                    if (data.error) toast.error('une erreur est survenu')
                },
                (err)=>{
                    console.log(err)
                    toast.error('une erreur est survenu')
                })
        }
        if(objType==='otherDocument'){
            ApiDatabase.postDeleteOtherDocument({ documentId: objID },
                (data)=>{
                    if (data.success) {
                        refreshLoadWorker()
                        toggle()
                        toast.success('Le document est supprimé.')
                    }
                    if (data.error) toast.error('une erreur est survenu')
                },
                (err)=>{
                    console.log(err)
                    toast.error('une erreur est survenu')
                })
        }
    }
    return (
        <>
                <Modalheader hide={toggle} hideShow={true}>Suppression  {objType === 'licence'? 'un permis' : objType === 'otherDocument' ? 'un document' : ' une formation'}</Modalheader>
                <ModalBody>
                    Êtes-vous sûr de vouloir supprimer {objType === 'licence'? 'ce permis' : objType === 'otherDocument' ? 'ce document' : 'cette formation'} ? Cette action est irréversible.
                </ModalBody>
                <ModalFooter>
                    <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>Annuler</Button>
                    <Button size={'LG'} onClick={handleDeleted}>Confirmer</Button>
                </ModalFooter>
        </>
    );
};

export default Modaldelete;